import { HistoryEvent } from '@api/types';
import { nameStartsWith } from '@react/constants/historyEvent/utils';

export function audienceParser(event: HistoryEvent): boolean {
  return nameStartsWith(event, 'audience_builder:');
}
